export enum FilterModalType {
    FILTERS = 'filters',
    SORT = 'sort',
    CANCELLATION_POLICY = 'cancellation_policy',
    SMART_SEARCH = 'smart_search',
}

export enum FilterType {
    BATHROOMS = 'bathrooms',
    BEDROOMS = 'bedrooms',
    BOOKING_TYPES = 'booking_types',
    CANCELLATION_POLICY = 'cancellation_policy',
    FEATS = 'feats',
    OFFERS = 'offers',
    POPULAR_FILTERS = 'populars' /* Popular filter logic is on frontend side */,
    PRICES = 'prices',
    PROPERTY_TYPES = 'property_types',
    STARS = 'stars',
    SUITED = 'suited',
    TOPICS = 'topics',
}

export enum FilterCollapsedState {
    FOLD = 'fold',
    UNFOLD = 'unfold',
}
